import { IState } from 'shared/store';

export const selectBookedFromDeveloperEnabled = (state: IState): boolean => state.rs.bookedFromDeveloperEnabled;
